const SWIPE_THRESHOLD_IN_PX = 150;

const dispatchSwipeEvent = (el, name) => {
  const event = new CustomEvent(name);
  el.dispatchEvent(event);
};

const calculateOpacity = (pxSwiped) => (pxSwiped === 0
  ? 1
  : (SWIPE_THRESHOLD_IN_PX / Math.abs(pxSwiped)) * 0.2);

export default {
  bind: (el) => {
    let pxSwiped = 0;
    let touchStartPosition = null;

    el.addEventListener('touchstart', (e) => {
      const firstTouch = e.touches[0];
      touchStartPosition = firstTouch.clientX;
    });

    el.addEventListener('touchmove', (e) => {
      const firstTouch = e.touches[0];
      pxSwiped = firstTouch.clientX - touchStartPosition;
      const opacity = calculateOpacity(pxSwiped);

      el.style.cssText = `opacity: ${opacity}; transform: translateX(${pxSwiped}px);`;
    });

    el.addEventListener('touchend', () => {
      if (pxSwiped <= -SWIPE_THRESHOLD_IN_PX) {
        dispatchSwipeEvent(el, 'swipeLeft');
      } else if (pxSwiped >= SWIPE_THRESHOLD_IN_PX) {
        dispatchSwipeEvent(el, 'swipeRight');
      }

      pxSwiped = 0;
      touchStartPosition = null;
      el.style = '';
    });
  },
};
